export default "__VITE_ASSET__TB_AKbS___"